<template>
  <div>
    <Topbar/>
    <Menu/>
    <v-content class="fs-content">
      <Breadcumb/>
      <div class="fs-main-content">
        <keep-alive>
          <router-view :key="$router.fullPath"/>
        </keep-alive>
      </div>
    </v-content>
    <Confirm ref="confirm"></Confirm>
    <Footer />
  </div>
</template>

<script>
import Confirm from '@/components/generic/confirm'
import Topbar from './topbar'
import Menu from './menu'
import Breadcumb from './breadcumb'
import Footer from './footer'
import { mapMutations } from 'vuex'

export default {
  components: {
    Confirm,
    Topbar,
    Menu,
    Breadcumb,
    Footer
  },
  data () {
    return {}
  },
  mounted () {
    this.setConfirm(this.$refs.confirm)
  },
  methods: {
    ...mapMutations({
      setConfirm: 'global/setConfirm'
    })
  }
}
</script>

<style>
.fs-content {
  background-color: #FAFAFA !important;
  height: 100vh;
  font-size: 13px !important;
}
.fs-main-content {
  padding: 12px;
  margin-bottom: 20px;
}
table {
  font-size: 12px !important;
}
th {
  padding-left: 15px !important;
  padding-right: 10px !important;
}
th {
  color: rgb(83, 83, 83);
  height: 32px !important;
  font-size: 11px !important;
}
td {
  font-size: 12px !important;
  color: rgb(82, 82, 82);
  height: 34px !important;
}
tr td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
tr:hover td {
  background-color: rgba(255, 255, 255, 0.39);
}
.fs-tr-selected {
  border-left: 3px solid blue;
  background-color: rgba(13, 58, 116, 0.116) !important;
}
.fs-tr-selected:hover {
  background-color: rgba(13, 58, 116, 0.116) !important;
}
.v-icon {
  font-size: 18px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 2px !important;
  font-size: 12px !important;
}
.v-input__icon--clear {
  margin-top: -3px !important;
}
body {
  font-size: 13px !important;
}
textarea:focus, input:focus, select:focus, button:focus {
  box-shadow: 0 0 0 0;
  border: 0;
  outline: 0;
}
.v-input .v-label {
  line-height: 17px !important;
  font-size: 14px;
}
.v-input__slot {
  margin-top: 2px;
  font-size: 12px !important;
}
.v-input__icon--append {
  margin-top: -4px !important;
  margin-right: -4px !important;
}
.v-menu__content {
  /* margin-top: -5px; */
  margin-top: 32px;
}
.v-list-item {
  min-height: 30px !important;
}
.v-list-item__title {
  font-size: 12px !important;
  font-weight: 400 !important;
}
.fs-chip {
  font-size: 11px !important;
  height: 20px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  letter-spacing: .5px !important;
}
</style>
